import template from './am-dashboard.html';
class AMDashboardController {
  constructor(accessManagementService) {
    'ngInject';
    this.accessManagementService = accessManagementService;
    this.assets = [];
    this.operators = [];
    this.errorMsg = null;
  }

  $onInit() {
    this.getAssets();
    this.getOperators();
  }
  getAssets() {
    this.accessManagementService
      .getAssets()
      .then(data => {
        this.updateUIData(data);
      })
      .catch(e => {
        this.errorMsg = 'Error loading assets Data';
      });
  }
  getOperators() {
    this.accessManagementService
      .getOperators()
      .then(data => {
        this.updateUIData(data);
      })
      .catch(e => {
        this.errorMsg = 'Error loading operators Data';
      });
  }
  updateUIData(storeData) {
    this.assets = storeData.assets;
    this.operators = storeData.operators;
  }
}
export default {
  template,
  controller: AMDashboardController,
  controllerAs: 'vm',
  bindings: {}
};
